import React, {useCallback, useState} from 'react';
import StorageSelector from '../../../components/storage/StorageSelector';
import ArticleSelector from '../../../components/article/ArticleSelector';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { usePostGoodsReceiptMutation } from '../../../redux/api/stockApi';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useApiErrorToast } from '../../../hooks/useApiError';

const BookGoodsReceipt = () => {
  const [storageLocation, setStorageLocation] = useState(null);
  const [articlesToBook, setArticlesToBook] = useState([]);
  const [postGR, { isLoading }] = usePostGoodsReceiptMutation();
  const navigate = useNavigate();
  const apiErrorToast = useApiErrorToast();

  const handleSetArticlesToBook = useCallback((newArticles) => {
    setArticlesToBook(newArticles);
  }, []);

  const removeLine = (indexToRemove) => {
    setArticlesToBook((prevArticles) =>
      prevArticles.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleChangeQuantity = (event, index) => {
    const newQuantity = parseInt(event.target.value) || 0;

    setArticlesToBook((prevArticles) => {
      const updatedArticles = [...prevArticles];
      updatedArticles[index].quantity = newQuantity;
      return updatedArticles;
    });
  };

  const handleSubmit = async () => {
    const postingObj = {
      movement_type: 'IN',
      to_storage_id: storageLocation,
      items: articlesToBook.map((artLine) => ({
        article_id: artLine.article.id,
        quantity: artLine.quantity,
      })),
    };
    try {
      await postGR(postingObj).unwrap();
      toast.success('Wareneingang gebucht!');
      navigate('/testing');
    } catch (err) {
      apiErrorToast(err, 'Fehler beim Buchen des Wareneingangs');
    }
  };

  return (
    <div>
      <h3>Wareneingang buchen</h3>
      <div className='row mt-5'>
        <div className='col-3'>
          <label htmlFor='storageLocation' className='col-form-label'>
            Lagerort für Eingang
          </label>
        </div>
        <div className='col-3'>
          <StorageSelector
            storageLocation={storageLocation}
            setStorageLocation={setStorageLocation}
          />
        </div>
      </div>
      <div className='row mt-3'>
        <div className='col-3'>
          <label htmlFor='article' className='col-form-label'>
            Artikel hinzufügen
          </label>
        </div>
        <div className='col-3'>
          <ArticleSelector
            articlesToBook={articlesToBook}
            setArticlesToBook={handleSetArticlesToBook}
          />
        </div>
      </div>
      <div className='mt-5'></div>
      {articlesToBook.length > 0 ? (
        <>
          <h4>Einzubuchende Artikel:</h4>
          <table className='table table-striped mt-3 align-middle'>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>Artikel</th>
                <th>Gebinde</th>
                <th>Menge</th>
                <th>in Paletten</th>
              </tr>
            </thead>
            <tbody>
              {articlesToBook?.map((artLine, index) => (
                <tr key={index}>
                  <td>
                    <button
                      className='btn btn-sm ps-0 text-danger border-0'
                      onClick={() => removeLine(index)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td>
                  <td>{artLine.article.name}</td>
                  <td>{artLine.article.unit.display_name}</td>
                  <td>
                    <input
                      className='form-control'
                      type='number'
                      value={artLine.quantity}
                      onChange={(event) => handleChangeQuantity(event, index)}
                    />
                  </td>
                  <td>
                    {artLine.article.unit.palletized
                      ? (() => {
                          const fullPallets = Math.floor(
                            artLine.quantity /
                              artLine.article.unit.pallet_factor
                          );
                          const remainder =
                            artLine.quantity %
                            artLine.article.unit.pallet_factor;
                          const unitName =
                            remainder > 1
                              ? artLine.article.unit.display_name_plural
                              : artLine.article.unit.display_name;
                          return remainder === 0
                            ? `${fullPallets} PAL`
                            : fullPallets > 0
                              ? `${fullPallets} PAL + ${remainder} ${unitName}`
                              : `${remainder} ${unitName}`;
                        })()
                      : 'nicht palletiert'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button
            className='btn btn-success'
            onClick={handleSubmit}
            disabled={isLoading}
          >
            Wareneingang buchen
          </button>
        </>
      ) : null}
    </div>
  );
};

export default BookGoodsReceipt;
